import React from 'react'
import Contactus from '../Components/Contactus'
import { Helmet } from 'react-helmet'

function Contactuspage() {
  return (

    <>
    <Helmet>
        <title>Contact Us - Get in Touch with St Johns College Jaffna</title>
        
        {/* SEO Meta Tags */}
        <meta
          name="description"
          content="Contact St Johns College Jaffna for any inquiries or questions. We're here to assist you with memberships, events, and more."
        />
        <meta
          name="keywords"
          content="Contact St Johns College Jaffna, sports club contact, inquiry, membership questions, club events, get in touch"
        />
        <meta name="robots" content="index, follow" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Contact St Johns College Jaffna" />
        <meta
          property="og:description"
          content="Reach out to St Johns College Jaffna for any questions regarding memberships, events, and more."
        />
        <meta property="og:url" content="https://stjohns.microwe.net/contactus" />
        <meta property="og:image" content="https://stjohns.microwe.net/images/og-contact-us.jpg" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Us - St Johns College Jaffna" />
        <meta name="twitter:description" content="Contact St Johns College Jaffna for inquiries regarding membership and events." />
        <meta name="twitter:image" content="https://stjohns.microwe.net/images/twitter-contact-us.jpg" />

        <meta charSet="utf-8" />
        <link rel="canonical" href="https://stjohns.microwe.net/contactus" />
      </Helmet>
    <div className='h-full pb-[154px] '>
      <Contactus/>
    </div>
    </>
  )
}

export default Contactuspage